// src/components/TabMenuComponent.js
import React, { useState, useEffect, useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { TabMenu } from 'primereact/tabmenu';

const TabMenuComponent = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [activeIndex, setActiveIndex] = useState(0);
  const [powerUser, setPowerUser] = useState(false);

  // Fetch the power user status from localStorage
  useEffect(() => {
    const isPowerUser = localStorage.getItem('isAppPowerUser') === 'true';
    setPowerUser(isPowerUser);
  }, []);

  // Use useMemo to memoize the menuItems array
  const menuItems = useMemo(() => {
    const items = [
      { label: 'Home', icon: 'pi pi-fw pi-home', to: '/' },
      { label: 'Tests', icon: 'pi pi-fw pi-list', to: '/tests' },
      { label: 'Configurations', icon: 'pi pi-fw pi-sliders-h', to: '/configurations' },
      // { label: 'Results', icon: 'pi pi-fw pi-chart-line', to: '/results' },
      // { label: 'Results-Proposal', icon:'pi pi-fw pi-chart-line', to: '/results-proposal' },
      { label: 'Infrastructure', icon: 'pi pi-fw pi-server', to: '/infrastructure' },
      { label: 'Artifacts', icon: 'pi pi-fw pi-file', to: '/artifacts' },
      
    ];

    // Conditionally add the 'Power Users' tab
    if (powerUser) {
      items.push({
        label: 'Power Users',
        icon: 'pi pi-fw pi-user',
        to: '/power-users',
      });
    }

    // Always add the 'Run Test' tab
    items.push({ label: 'Run Test', icon: 'pi pi-fw pi-play', to: '/run' });

    return items;
  }, [powerUser]); // Recompute when powerUser changes

  // Update activeIndex whenever location or menuItems change
  useEffect(() => {
    const activeItem = menuItems.findIndex((item) => item.to === location.pathname);
    setActiveIndex(activeItem !== -1 ? activeItem : 0);
  }, [location.pathname, menuItems]);

  const handleTabChange = (e) => {
    setActiveIndex(e.index);
    navigate(menuItems[e.index].to);
  };

  return (
    <div className="fixed-tab-menu">
      <TabMenu
        model={menuItems}
        activeIndex={activeIndex}
        onTabChange={handleTabChange}
      />
    </div>
  );
};

export default TabMenuComponent;
